import React, {useState} from "react";
import Sidebar from "../../components/sidebar/sidebar";
import styles from "../home/home.module.css";
import ToastContainer from "../../components/toasts/toast/toast_container";
import {Button, Radio, Text} from "../../components/inputs/ajonjolinput";
import {handleSendMessage} from "../../utils/serial";

function Title({children}) {
    return (
        <div className={styles.inputTitle}>
            {children}
        </div>
    )
}

function Section({description, children}) {
    return (
        <div className={styles.section}>
            <div className={styles.description} style={{
                marginTop: '1rem'
            }}>{description}</div>
            <div className={styles.optionsContainer}>
                {children}
            </div>
        </div>
    )
}

export default function Calibration() {
    const [form, setForm] = useState({
        antenna: 'Antenna 1',
        distance: 10,
    });

    return (
        <div style={{height: '100vh'}}>
            <Sidebar/>
            <div className={styles.container}>
                <div style={{display: 'flex', flexDirection: 'column', width: '90%', marginTop: '3rem'}}>
                    <div className={styles.title}>Calibration</div>
                    <Section description={'Calibration parameters'}>
                        <Radio.Group value={form['antenna']} onChange={(value) => {
                            setForm({
                                ...form,
                                "antenna": value
                            });
                        }}>
                            <Radio.Input value={'Antenna 1'}/>
                            <Radio.Input value={'Antenna 2'}/>
                        </Radio.Group>

                        <div style={{marginBottom: '1rem'}}/>

                        <Title>Distance</Title>
                        <Text placeholder={'Distance'} value={form['distance']} onChange={(value) => {
                            setForm({
                                ...form,
                                "distance": value
                            })
                        }}/>
                    </Section>
                    <Section description={''}>
                        <div style={{
                            display: 'flex',
                            marginLeft: 'auto',
                            marginTop: '1rem'
                        }}>
                            <Button variant={'success'} name={'Calibrate'} onSubmit={() => handleSendMessage(form)}/>
                        </div>
                    </Section>
                </div>
            </div>
            <ToastContainer/>
        </div>
    )
}